const COMPANY_VALUE = "companyValue"
const COMPANY_VALUE_FIRST_CHAR = "#"
const DEFAULT_MAX_SEARCH_RESULTS = 30
const EMOJI = "emoji"
const EMOJI_FIRST_CHAR = ":"
const SUPPRESSED_LIST = ["eggplant", "face_with_symbols_on_mouth", "hankey", "middle_finger", "peach", "poop"]

export {COMPANY_VALUE, COMPANY_VALUE_FIRST_CHAR, DEFAULT_MAX_SEARCH_RESULTS, EMOJI, EMOJI_FIRST_CHAR, SUPPRESSED_LIST}
